import React from 'react'

export default function BannerFact() {
  return (
    <div className="banner-fact">
  <div className="container">
    <div className="row gy-lg-0 gy-4">
      <div className="col-lg-3 col-md-5 wow fadeInRight" data-wow-delay="0.1s">
        <div className="single-fact" >
          <div className="icon">
            <i className="fas fa-globe" />
          </div>
          <p className='p-3'> 50+ Banks</p>
        </div>
      </div>
      <div className="col-lg-3 col-md-5 wow fadeInRight" data-wow-delay="0.4s">
        <div className="single-fact">
          <div className="icon">
            <i className="fas fa-user" />
          </div>
          <p>Contactless KYC & Paperless Approval</p>
        </div>
      </div>
      <div
        className="col-lg-3 col-md-5 wow fadeInRight mx-auto"
        data-wow-delay="0.7s"
      >
        <div className="single-fact">
          <div className="icon">
            <i className="fas fa-briefcase" />
          </div>
          <p>7,000+ Happy Customers</p>
        </div>
      </div>
      <div
        className="col-lg-3 col-md-5 wow fadeInRight mx-auto"
        data-wow-delay="0.7s"
      >
        <div className="single-fact">
          <div className="icon">
            <i className="fas fa-briefcase" />
          </div>
          <p>Exclusive Offers & Rates</p>
        </div>
      </div>
    </div>
  </div>
</div>

  )
}
